// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @bitwarden/platform/no-enums
export enum WebauthnLoginCredentialPrfStatus {
  Enabled = 0,
  Supported = 1,
  Unsupported = 2,
}
